<template>
    <div class="moderator-search">
        <v-icon @click="searchPopup = !searchPopup" :size="25">mdi-magnify</v-icon>
        <div v-if="searchPopup" class="moderator-search__popup">
            <v-app>
                <div class="moderator-search__popup-container">
                    <h4 class="title moderator-search__popup-header">{{$t('search')}}</h4>
                    <v-icon class="moderator-search__popup-close" @click="searchPopup = false">mdi-close</v-icon>
                    <div class="moderator-search__search-container d-flex justify-space-between align-center">
                        <v-text-field
                        @keyup.enter="searchFunc(search)"
                        outlined
                        v-model.trim="search"
                        :placeholder="$t('search')"
                        :append-outer-icon="'mdi-send'"
                        :color="$mainColor"
                        @click:append-outer="searchFunc(search)"
                        ></v-text-field>
                    </div>
                    <div v-if="resultSearchRequest" class="list" style="width: 100%;">
                        <ul style="padding-left:10px;">
                            <li style="cursor:pointer;" class="d-flex justify-space-between align-center"
                             v-for="(item, index) in GETTERS_RESULT_SEARCH_MODERATOR_REQUEST" :key="index"
                             @click="open_proposal_card(item.id, item.name)">
                                <div style="width: 100%;">
                                <strong> №{{item.id}} {{item.name ? item.name: $t('ModeratorSearch.application_not_specified')}} </strong><br>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-if="laodSearch" class="preloader-not-search">
                        <v-progress-linear
                        indeterminate
                        color="#16336E"
                        ></v-progress-linear>
                    </div>
                    <div v-if="notDataSearch" class="not-data-search">
                        <h4 class="title">
                            {{$t('no_data')}}
                        </h4>
                    </div>
                </div>
            </v-app>
        </div>
    </div>
</template>
<script>

import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    name: 'ModeratorSearch',
    data: () => ({
      searchPopup: false,
      search: '',
      notDataSearch: true,
      laodSearch: false,
      call_id: null,
    }),
    methods: {
        ...mapActions(['GET_SEARCH_MODERATOR_REQUEST']),
        
        ...mapMutations([
            'SHOW_PROPOSAL_CARD',
        ]),

        open_proposal_card(id) {
            this.call_id = new Date()
            this.SHOW_PROPOSAL_CARD({
                'proposal_id' : id,
                'call_id': this.call_id
            })
        },
        
        searchFunc(val) {
            this.notDataSearch = false
            this.laodSearch = true
            this.GET_SEARCH_MODERATOR_REQUEST(val)
      },

    },
    computed: {
        ...mapGetters(['GETTERS_RESULT_SEARCH_MODERATOR_REQUEST']),
        resultSearchRequest() {
            return (this.GETTERS_RESULT_SEARCH_MODERATOR_REQUEST !== null) &&
            (Array.isArray(this.GETTERS_RESULT_SEARCH_MODERATOR_REQUEST) &&
            (this.GETTERS_RESULT_SEARCH_MODERATOR_REQUEST.length !== 0))   
        }
    },
    watch: {
        GETTERS_RESULT_SEARCH_MODERATOR_REQUEST(val) {

            this.laodSearch = false

            if (val === null) this.notDataSearch = true;
            else if (Array.isArray(val) && val.length === 0) this.notDataSearch = true;
            else this.notDataSearch = false
        }
    },
    components: {
    }
}
</script>
<style scoped>
.moderator-search__popup {
    position: fixed;
    top: 48px;
    right: 0;
    height: calc(100vh - 48px);
    max-width: 400px;
    width: 100%;
    background: white;
    border-radius: 5px;
    margin: 5px 5px 5px 0;
    padding: 15px;
    box-shadow: 1px 1px 10px 1px rgba(0,0,0, .4);
}
.moderator-search__popup-container {
    position: relative;
}
.moderator-search__popup-header {
    margin-bottom: 15px;
    color: black;
}
.moderator-search__popup-close {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    color: black;
}

.list ul {
    padding: 10px;
    overflow-y: auto;
    height: 71.5vh;
}
</style>
